// Rule Builder domain: catalogs, types, helpers, simulator (ported from Lumina Billing).

export const FIELD_GROUPS = [
  {
    key: "patient", label: "Patient", category: "Patient",
    fields: [
      { path: "patient.id", label: "Patient ID", type: "text" },
      { path: "patient.patient_registration_number", label: "Registration #", type: "text" },
      { path: "patient.gender", label: "Gender", type: "enum", enumValues: ["MALE", "FEMALE", "OTHER"] },
      { path: "patient.dob", label: "Date of Birth", type: "date" },
      { path: "patient.age", label: "Age", type: "number", hint: "derived from DOB" },
      { path: "patient.nationality", label: "Nationality", type: "text" },
      { path: "patient.city", label: "City", type: "text" },
      { path: "patient.state", label: "State", type: "text" },
      { path: "patient.country", label: "Country", type: "text" },
      { path: "patient.is_active", label: "Is Active", type: "boolean" },
      { path: "patient.metadata.vip", label: "VIP", type: "boolean" },
    ],
  },
  {
    key: "encounter", label: "Encounter / Visit", category: "Encounter",
    fields: [
      { path: "encounter.id", label: "Encounter ID", type: "text" },
      { path: "encounter.encounter_number", label: "Encounter #", type: "text" },
      { path: "encounter.encounter_type", label: "Encounter Type", type: "enum", enumValues: ["OPD", "IPD", "EMERGENCY", "DAYCARE"] },
      { path: "encounter.encounter_type_code", label: "Encounter Type Code", type: "text" },
      { path: "encounter.encounter_type_name", label: "Encounter Type Name", type: "text" },
      { path: "encounter.status", label: "Status", type: "enum", enumValues: ["REGISTERED", "ADMITTED", "DISCHARGED", "CANCELLED"] },
      { path: "encounter.payer_type", label: "Payer Type", type: "enum", enumValues: ["SELF", "TPA", "INSURANCE", "CORPORATE"] },
      { path: "encounter.billing_status", label: "Billing Status", type: "text" },
      { path: "encounter.encounter_date", label: "Encounter Date", type: "date" },
      { path: "encounter.admission_time", label: "Admission Time", type: "datetime" },
      { path: "encounter.discharge_time", label: "Discharge Time", type: "datetime" },
      { path: "encounter.department_id", label: "Department ID", type: "text" },
      { path: "encounter.department_name_snapshot", label: "Department Name", type: "text" },
      { path: "encounter.provider_id", label: "Practitioner Name", type: "text" },
      { path: "encounter.provider_name_snapshot", label: "Practitioner Name (text)", type: "text" },
      { path: "encounter.payer_id", label: "Payer ID", type: "text" },
      { path: "encounter.payer_name_snapshot", label: "Payer Name", type: "text" },
      { path: "encounter.ward_id", label: "Ward ID", type: "text" },
      { path: "encounter.ward_name_snapshot", label: "Ward Name", type: "text" },
      { path: "encounter.room_id", label: "Room ID", type: "text" },
      { path: "encounter.room_number_snapshot", label: "Room #", type: "text" },
      { path: "encounter.bed_id", label: "Bed ID", type: "text" },
      { path: "encounter.bed_number_snapshot", label: "Bed #", type: "text" },
    ],
  },
  {
    key: "charge_event", label: "Charge Event", category: "Charge",
    fields: [
      { path: "charge_event.id", label: "Charge Event ID", type: "text" },
      { path: "charge_event.source_system", label: "Source System", type: "text" },
      { path: "charge_event.source_module", label: "Source Module", type: "text" },
      { path: "charge_event.event_type", label: "Event Type", type: "enum", enumValues: ["CHARGE", "REVERSAL", "ADJUSTMENT"] },
      { path: "charge_event.category", label: "Category", type: "enum", enumValues: ["ROOM_RENT", "CONSULTATION", "PROCEDURE", "LAB", "RADIOLOGY", "PHARMACY", "NURSING", "PACKAGE", "MISC"] },
      { path: "charge_event.service_code", label: "Service Code", type: "text" },
      { path: "charge_event.service_name", label: "Service Name", type: "text" },
      { path: "charge_event.quantity", label: "Quantity", type: "number" },
      { path: "charge_event.unit", label: "Unit", type: "text" },
      { path: "charge_event.unit_price", label: "Unit Price", type: "number" },
      { path: "charge_event.gross_amount", label: "Gross Amount", type: "number" },
      { path: "charge_event.event_time", label: "Event Time", type: "datetime" },
      { path: "charge_event.charge_day_sequence", label: "Charge Day Sequence", type: "number" },
      { path: "charge_event.processing_status", label: "Processing Status", type: "text" },
      { path: "charge_event.metadata", label: "Metadata", type: "text" },
    ],
  },
  {
    key: "billing_account", label: "Billing Account", category: "Billing",
    fields: [
      { path: "billing_account.id", label: "Billing Account ID", type: "text" },
      { path: "billing_account.account_status", label: "Account Status", type: "enum", enumValues: ["OPEN", "CLOSED", "CANCELLED", "HOLD"] },
      { path: "billing_account.gross_amount", label: "Gross", type: "number" },
      { path: "billing_account.discount_amount", label: "Discount", type: "number" },
      { path: "billing_account.tax_amount", label: "Tax", type: "number" },
      { path: "billing_account.net_amount", label: "Net", type: "number" },
      { path: "billing_account.paid_amount", label: "Paid", type: "number" },
      { path: "billing_account.outstanding_amount", label: "Outstanding", type: "number" },
      { path: "billing_account.deposit_amount", label: "Deposit", type: "number" },
      { path: "billing_account.insurance_claim_amount", label: "Claim", type: "number" },
      { path: "billing_account.insurance_approved_amount", label: "Approved", type: "number" },
    ],
  },
  {
    key: "payer", label: "Payer / Insurance / Corporate", category: "Payer",
    fields: [
      { path: "payer.id", label: "Payer ID", type: "text" },
      { path: "payer.payer_code", label: "Payer Code", type: "text" },
      { path: "payer.payer_name", label: "Payer Name", type: "text" },
      { path: "payer.payer_type", label: "Payer Type", type: "enum", enumValues: ["SELF", "TPA", "INSURANCE", "CORPORATE"] },
      { path: "payer.credit_period_days", label: "Credit Period (days)", type: "number" },
      { path: "payer.settlement_cycle_days", label: "Settlement (days)", type: "number" },
      { path: "payer.is_active", label: "Active", type: "boolean" },
      { path: "payer.metadata", label: "Metadata", type: "text" },
    ],
  },
  {
    key: "department", label: "Department", category: "Location",
    fields: [
      { path: "department.id", label: "Dept ID", type: "text" },
      { path: "department.department_code", label: "Dept Code", type: "text" },
      { path: "department.department_name", label: "Dept Name", type: "text" },
      { path: "department.is_clinical", label: "Is Clinical", type: "boolean" },
      { path: "department.is_active", label: "Active", type: "boolean" },
    ],
  },
  {
    key: "ward_room_bed", label: "Ward / Room / Bed", category: "Location",
    fields: [
      { path: "ward.id", label: "Ward ID", type: "text" },
      { path: "ward.ward_code", label: "Ward Code", type: "text" },
      { path: "ward.ward_name", label: "Ward Name", type: "text" },
      { path: "ward.ward_type", label: "Ward Type", type: "text" },
      { path: "ward.floor_number", label: "Floor #", type: "number" },
      { path: "room.id", label: "Room ID", type: "text" },
      { path: "room.room_number", label: "Room #", type: "text" },
      { path: "room.room_type", label: "Room Type", type: "text" },
      { path: "room.floor_number", label: "Floor #", type: "number" },
      { path: "bed.id", label: "Bed ID", type: "text" },
      { path: "bed.bed_number", label: "Bed #", type: "text" },
      { path: "bed.bed_type", label: "Bed Type", type: "text" },
      { path: "bed.occupancy_status", label: "Occupancy", type: "text" },
      { path: "bed.daily_charge", label: "Daily Charge", type: "number" },
    ],
  },
  // An "Existing Pricing Rule" group used to sit here. Nothing puts a `pricing_rule`
  // namespace into an evaluation context and the engine refuses it on save, so all twelve
  // fields could only ever answer 422. They described the rule being written rather than the
  // charge being priced. This list is only the fallback for when the server's catalog cannot
  // be fetched; the server's copy dropped them too.
];

export const ALL_FIELDS = FIELD_GROUPS.flatMap((g) => g.fields);

/** Default field path when overriding unit price on a charge line */
export const DEFAULT_PRICE_OVERRIDE_TARGET = "charge_event.unit_price";

/** Default target_field per action type when adding from UI */
export const DEFAULT_ACTION_TARGETS = {
  price_override: "charge_event.unit_price",
  discount: "charge_event.gross_amount",
  tax: "charge_event.gross_amount",
  markup: "charge_event.unit_price",
  approval: "charge_event.gross_amount",
  remark: "charge_event.id",
  set_billing_category: "charge_event.category",
};

/** All catalog fields selectable as action target_field */
export function getActionTargetFields(fieldGroups = FIELD_GROUPS) {
  return fieldGroups.flatMap((g) =>
    g.fields.map((f) => ({ path: f.path, label: f.label, group: g.label, type: f.type })),
  );
}

/** @deprecated use getActionTargetFields */
export function getPriceTargetFields(fieldGroups = FIELD_GROUPS) {
  return getActionTargetFields(fieldGroups).filter((f) => f.type === "number");
}
export const CATEGORIES = ["Patient", "Encounter", "Charge", "Billing", "Payer", "Location"];

export const OPERATORS = [
  { code: "eq", label: "Equals", arity: "one" },
  { code: "neq", label: "Not Equals", arity: "one" },
  { code: "gt", label: "Greater Than", arity: "one" },
  { code: "gte", label: "Greater Than or Equal", arity: "one" },
  { code: "lt", label: "Less Than", arity: "one" },
  { code: "lte", label: "Less Than or Equal", arity: "one" },
  { code: "in", label: "In List", arity: "list" },
  { code: "not_in", label: "Not In List", arity: "list" },
  { code: "contains", label: "Contains", arity: "one" },
  { code: "starts_with", label: "Starts With", arity: "one" },
  { code: "ends_with", label: "Ends With", arity: "one" },
  { code: "between", label: "Between", arity: "two" },
  { code: "time_between", label: "Time Between", arity: "time_range" },
  { code: "is_null", label: "Is Null", arity: "none" },
  { code: "is_not_null", label: "Is Not Null", arity: "none" },
];

const ESSENTIAL_FIELD_PATHS = ["charge_event.charge_day_sequence"];

/** Ensure catalog from API includes fields required for common IPD bed rules */
export function enrichFieldGroups(groups) {
  const essential = ESSENTIAL_FIELD_PATHS.map((path) => ALL_FIELDS.find((f) => f.path === path)).filter(Boolean);
  if (!essential.length) return groups;
  const has = (path) => groups.some((g) => g.fields?.some((f) => f.path === path));
  const missing = essential.filter((f) => !has(f.path));
  if (!missing.length) return groups;
  return groups.map((g) => {
    if (g.key !== "charge_event") return g;
    return { ...g, fields: [...(g.fields || []), ...missing] };
  });
}

/** Catalog operator codes plus UI-only operators (e.g. time_between) */
export function resolveOperators(catalogCodes) {
  if (!catalogCodes?.length) return [...OPERATORS];
  const list = catalogCodes.map((code) => {
    const found = OPERATORS.find((o) => o.code === code);
    return found ?? { code, label: code, arity: "one" };
  });
  const timeBetween = OPERATORS.find((o) => o.code === "time_between");
  if (timeBetween && !list.some((o) => o.code === "time_between")) list.push(timeBetween);
  return list;
}

export function parseTimeRangeValue(value) {
  if (value && typeof value === "object" && !Array.isArray(value)) {
    return { from: String(value.from ?? ""), to: String(value.to ?? "") };
  }
  if (Array.isArray(value)) {
    return { from: String(value[0] ?? ""), to: String(value[1] ?? "") };
  }
  const parts = String(value ?? "").split(",");
  return { from: parts[0]?.trim() ?? "", to: parts[1]?.trim() ?? "" };
}

function timeToMinutes(t) {
  const m = String(t ?? "").match(/(\d{1,2}):(\d{2})/);
  if (!m) return NaN;
  return Number(m[1]) * 60 + Number(m[2]);
}

function actualTimeMinutes(actual) {
  const s = String(actual ?? "");
  const timePart = s.includes("T") ? s.split("T")[1]?.slice(0, 8) : s;
  return timeToMinutes(timePart.slice(0, 5));
}

export const RULE_TYPES = ["PRICE_OVERRIDE", "DISCOUNT", "TAX", "MARKUP", "APPROVAL", "VALIDATION", "COMPOSITE", "DOCTOR_PAYOUT"];

export const uid = () => Math.random().toString(36).slice(2, 10);

export function newCond(field = "", operator = "eq") {
  return { id: uid(), kind: "cond", field, operator, value: "", enabled: true };
}

export function newGroup(type = "all") {
  return { id: uid(), kind: "group", type, children: [] };
}

export function fieldDef(path) {
  return ALL_FIELDS.find((f) => f.path === path);
}

function condJSON(c) {
  const op = OPERATORS.find((o) => o.code === c.operator);
  const out = { field: c.field, operator: c.operator };
  if (!op || op.arity === "none") return out;
  out.value = coerceValue(c);
  return out;
}

function groupJSON(g) {
  const kids = g.children
    .filter((k) => k.kind === "group" || (k.kind === "cond" && k.enabled))
    .map((k) => (k.kind === "cond" ? condJSON(k) : groupJSON(k)));
  if (g.type === "not") return { not: kids[0] ?? {} };
  return { [g.type]: kids };
}

/** API conditions → UI GroupNode tree */
export function parseConditionsFromApi(apiConditions) {
  if (!apiConditions || typeof apiConditions !== "object") {
    return { ...newGroup("all") };
  }
  if (Array.isArray(apiConditions.all)) {
    return { ...newGroup("all"), children: apiConditions.all.map(parseApiConditionNode).filter(Boolean) };
  }
  if (Array.isArray(apiConditions.any)) {
    return { ...newGroup("any"), children: apiConditions.any.map(parseApiConditionNode).filter(Boolean) };
  }
  if (apiConditions.not !== undefined && apiConditions.not !== null) {
    const child = parseApiConditionNode(apiConditions.not);
    return { ...newGroup("not"), children: child ? [child] : [] };
  }
  if (apiConditions.field) {
    return { ...newGroup("all"), children: [parseCondFromApi(apiConditions)] };
  }
  return { ...newGroup("all") };
}

function parseApiConditionNode(node) {
  if (!node || typeof node !== "object") return null;
  if (node.all || node.any || node.not !== undefined) {
    return parseConditionsFromApi(node);
  }
  if (node.field) return parseCondFromApi(node);
  return null;
}

function parseCondFromApi(c) {
  const op = OPERATORS.find((o) => o.code === (c.operator || "eq"));
  let value = c.value ?? "";
  if (op?.arity === "time_range") value = parseTimeRangeValue(c.value);
  return {
    ...newCond(c.field, c.operator || "eq"),
    value,
    enabled: true,
  };
}

export function ruleDefinitionToRuleState(item) {
  return {
    rule_set_id: String(item.rule_set_id ?? "").trim(),
    rule_code: item.rule_code ?? "",
    rule_name: item.rule_name ?? "",
    rule_type: item.rule_type ?? "DISCOUNT",
    description: item.description ?? "",
    priority: item.priority ?? 1,
    conditions: parseConditionsFromApi(item.conditions),
    actions: item.actions ?? {},
    stop_processing: item.stop_processing ?? false,
    is_active: item.is_active ?? true,
    effective_from: item.effective_from ?? "",
    effective_to: item.effective_to ?? null,
    metadata: item.metadata ?? {},
  };
}

export function mapRuleSet(item) {
  return {
    id: String(item.id).trim(),
    code: item.rule_set_code,
    name: item.rule_set_name,
    domain: item.metadata?.ui_domain ?? item.rule_domain,
    priority: item.priority ?? 1,
    effective_from: item.effective_from,
    active: item.is_active ?? true,
  };
}

/** Next code: RS-IPD-2026-1, RS-IPD-2026-2, … (bare RS-IPD-2026 counts as slot 0) */
export function generateNextRuleSetCode(codePrefix, year, existingCodes = []) {
  const base = `${String(codePrefix ?? "RS-").trim()}${year}`;
  const escape = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const suffixRe = new RegExp(`^${escape(base)}-(\\d+)$`, "i");
  let maxSuffix = 0;
  existingCodes.forEach((raw) => {
    const c = String(raw ?? "").trim().toUpperCase();
    if (!c) return;
    if (c === base.toUpperCase()) maxSuffix = Math.max(maxSuffix, 0);
    const m = c.match(suffixRe);
    if (m) maxSuffix = Math.max(maxSuffix, Number(m[1]));
  });
  return `${base}-${maxSuffix + 1}`;
}

export function mapRuleDefinitionToRow(item) {
  return {
    id: String(item.id).trim(),
    rule: ruleDefinitionToRuleState(item),
  };
}

export function emptyRuleForSet(ruleSetId) {
  return {
    rule_set_id: String(ruleSetId).trim(),
    rule_code: "",
    rule_name: "",
    rule_type: "DISCOUNT",
    description: "",
    priority: 1,
    conditions: { ...newGroup("all") },
    actions: {},
    stop_processing: false,
    is_active: true,
    effective_from: new Date().toISOString().slice(0, 10),
    effective_to: null,
    metadata: { source: "rule_builder_ui" },
  };
}

export function buildRuleJSON(r) {
  return {
    rule_set_id: String(r.rule_set_id).trim(),
    rule_code: r.rule_code,
    rule_name: r.rule_name,
    rule_type: r.rule_type,
    description: r.description,
    priority: r.priority,
    conditions: groupJSON(r.conditions),
    actions: cleanActions(r.actions),
    stop_processing: r.stop_processing,
    is_active: r.is_active,
    effective_from: r.effective_from,
    effective_to: r.effective_to,
    metadata: r.metadata,
  };
}

function cleanActions(a) {
  const out = {};
  Object.entries(a).forEach(([k, v]) => {
    if (v && typeof v === "object") {
      const filtered = Object.fromEntries(
        Object.entries(v).filter(([, x]) => x !== "" && x !== undefined && x !== null),
      );
      if (Object.keys(filtered).length) out[k] = filtered;
    }
  });
  return out;
}

function coerceValue(c) {
  const def = fieldDef(c.field);
  const op = OPERATORS.find((o) => o.code === c.operator);
  if (!op) return c.value;
  if (op.arity === "list") {
    if (Array.isArray(c.value)) return c.value;
    return String(c.value ?? "").split(",").map((s) => s.trim()).filter(Boolean);
  }
  if (op.arity === "time_range") {
    const range = parseTimeRangeValue(c.value);
    return { from: range.from, to: range.to };
  }
  if (op.arity === "two") {
    if (c.value && typeof c.value === "object" && !Array.isArray(c.value) && ("from" in c.value || "to" in c.value)) {
      return {
        from: def?.type === "number" ? Number(c.value.from) : c.value.from,
        to: def?.type === "number" ? Number(c.value.to) : c.value.to,
      };
    }
    const arr = Array.isArray(c.value) ? c.value : String(c.value ?? "").split(",");
    return arr.map((x) => (def?.type === "number" ? Number(x) : x));
  }
  if (def?.type === "number") return Number(c.value);
  if (def?.type === "boolean") return c.value === true || c.value === "true";
  return c.value;
}

export function validateRule(r) {
  const errors = [];
  if (!r.rule_code) errors.push("Rule code is required");
  if (!r.rule_name) errors.push("Rule name is required");
  if (!r.rule_type) errors.push("Rule type is required");
  if (!Number.isFinite(r.priority)) errors.push("Priority must be numeric");
  if (!r.effective_from) errors.push("Effective from is required");

  const conds = collectConds(r.conditions);
  if (conds.length === 0) errors.push("At least one condition is required");
  conds.forEach((c, i) => {
    if (!c.field) errors.push(`Condition ${i + 1}: field required`);
    const op = OPERATORS.find((o) => o.code === c.operator);
    if (!op || op.arity === "none") return;
    if (op.arity === "time_range") {
      const range = parseTimeRangeValue(c.value);
      if (!range.from || !range.to) errors.push(`Condition ${i + 1}: from and to times required`);
      return;
    }
    if (c.value === "" || c.value === undefined || c.value === null) {
      errors.push(`Condition ${i + 1}: value required`);
    }
  });
  if (Object.keys(cleanActions(r.actions)).length === 0) errors.push("At least one action is required");

  const actionLabels = {
    price_override: "Price override",
    discount: "Discount",
    tax: "Tax",
    markup: "Markup",
    approval: "Approval",
    remark: "Remark",
    set_billing_category: "Set billing category",
  };
  Object.entries(actionLabels).forEach(([key, label]) => {
    const block = r.actions[key];
    if (block && !block.target_field) errors.push(`${label}: target field is required`);
  });

  if (r.actions.price_override) {
    const po = r.actions.price_override;
    if (po.unit_price === "" || po.unit_price === undefined || po.unit_price === null) {
      errors.push("Price override: unit price is required");
    }
  }
  return errors;
}

function collectConds(g) {
  const out = [];
  g.children.forEach((c) => {
    if (c.kind === "cond") out.push(c);
    else out.push(...collectConds(c));
  });
  return out;
}

export function getByPath(obj, path) {
  return path.split(".").reduce((acc, k) => {
    if (acc && typeof acc === "object") return acc[k];
    return undefined;
  }, obj);
}

function evalCond(c, ctx) {
  if (!c.enabled) return { node: c, result: "skip", actual: undefined };
  const actual = getByPath(ctx, c.field);
  const v = coerceValue(c);
  let pass = false;
  switch (c.operator) {
    case "eq": pass = actual == v; break;
    case "neq": pass = actual != v; break;
    case "gt": pass = Number(actual) > Number(v); break;
    case "gte": pass = Number(actual) >= Number(v); break;
    case "lt": pass = Number(actual) < Number(v); break;
    case "lte": pass = Number(actual) <= Number(v); break;
    case "in": pass = Array.isArray(v) && v.map(String).includes(String(actual)); break;
    case "not_in": pass = Array.isArray(v) && !v.map(String).includes(String(actual)); break;
    case "contains": pass = String(actual ?? "").includes(String(v)); break;
    case "starts_with": pass = String(actual ?? "").startsWith(String(v)); break;
    case "ends_with": pass = String(actual ?? "").endsWith(String(v)); break;
    case "between": {
      const arr = v;
      if (arr && typeof arr === "object" && !Array.isArray(arr) && arr.from !== undefined) {
        pass = Number(actual) >= Number(arr.from) && Number(actual) <= Number(arr.to);
      } else {
        pass = Number(actual) >= Number(arr[0]) && Number(actual) <= Number(arr[1]);
      }
      break;
    }
    case "time_between": {
      const range = v && typeof v === "object" ? v : parseTimeRangeValue(v);
      const from = timeToMinutes(range.from);
      const to = timeToMinutes(range.to);
      const mins = actualTimeMinutes(actual);
      pass = Number.isFinite(from) && Number.isFinite(to) && Number.isFinite(mins) && mins >= from && mins <= to;
      break;
    }
    case "is_null": pass = actual === null || actual === undefined; break;
    case "is_not_null": pass = actual !== null && actual !== undefined; break;
    default: break;
  }
  return { node: c, result: pass ? "pass" : "fail", actual };
}

export function evalGroup(g, ctx) {
  const childTraces = g.children.map((c) =>
    (c.kind === "cond" ? evalCond(c, ctx) : evalGroup(c, ctx)),
  );
  const activeChildren = childTraces.filter((t) => t.result !== "skip");
  let result = true;
  if (g.type === "all") result = activeChildren.every(isPass);
  else if (g.type === "any") result = activeChildren.some(isPass);
  else if (g.type === "not") result = !activeChildren.some(isPass);
  return { node: g, result, children: childTraces };
}

function isPass(t) {
  if (t.children) return t.result;
  return t.result === "pass";
}

export function makeTemplate(key) {
  const base = {
    rule_set_id: "7602acbe-ef31-41a2-a0a7-c40383710864",
    rule_code: "",
    rule_name: "",
    rule_type: "DISCOUNT",
    description: "",
    priority: 1,
    conditions: { ...newGroup("all") },
    actions: {},
    stop_processing: false,
    is_active: true,
    effective_from: "2026-01-01",
    effective_to: null,
    metadata: { source: "rule_builder_ui" },
  };

  switch (key) {
    case "icu-tpa":
      return {
        ...base,
        rule_code: "RULE-ICU-BED-TPA-001",
        rule_name: "ICU bed charge for TPA IPD patient",
        rule_type: "PRICE_OVERRIDE",
        description: "Apply ICU bed daily charge with no discount and no tax.",
        stop_processing: true,
        conditions: {
          ...newGroup("all"),
          children: [
            { ...newCond("encounter.encounter_type", "eq"), value: "IPD" },
            { ...newCond("encounter.payer_type", "eq"), value: "TPA" },
            { ...newCond("charge_event.category", "eq"), value: "ROOM_RENT" },
            { ...newCond("charge_event.service_code", "eq"), value: "ICU-BED-DAY" },
          ],
        },
        actions: {
          price_override: {
            target_field: DEFAULT_PRICE_OVERRIDE_TARGET,
            unit_price: "9500.00",
            currency_code: "INR",
            reason: "ICU bed daily charge",
          },
          discount: { discount_type: "FIXED", discount_value: "0.00" },
          tax: { tax_percentage: "0.00" },
        },
      };
    case "senior-opd":
      return {
        ...base,
        rule_code: "RULE-OPD-SENIOR-DISCOUNT-001",
        rule_name: "15 percent discount for senior citizen OPD patients",
        description: "Apply 15% discount for OPD patients aged 60 or above.",
        conditions: {
          ...newGroup("all"),
          children: [
            { ...newCond("encounter.encounter_type", "eq"), value: "OPD" },
            { ...newCond("patient.age", "gte"), value: 60 },
          ],
        },
        actions: {
          discount: {
            target_field: DEFAULT_ACTION_TARGETS.discount,
            discount_type: "PERCENTAGE",
            discount_value: "15.00",
          },
        },
      };
    case "vip":
      return {
        ...base,
        rule_code: "RULE-VIP-DISCOUNT-001",
        rule_name: "VIP patient 20% discount",
        description: "Flat 20% discount for VIP patients.",
        conditions: { ...newGroup("all"), children: [{ ...newCond("patient.metadata.vip", "eq"), value: true }] },
        actions: {
          discount: {
            target_field: DEFAULT_ACTION_TARGETS.discount,
            discount_type: "PERCENTAGE",
            discount_value: "20.00",
          },
        },
      };
    case "high-value":
      return {
        ...base,
        rule_code: "RULE-APPROVAL-HIGHVALUE-001",
        rule_name: "Billing Manager approval for high value charges",
        rule_type: "APPROVAL",
        description: "Require Billing Manager approval for gross amount above 50,000.",
        conditions: { ...newGroup("all"), children: [{ ...newCond("charge_event.gross_amount", "gt"), value: 50000 }] },
        actions: {
          approval: {
            target_field: DEFAULT_ACTION_TARGETS.approval,
            approval_required: true,
            approval_role: "Billing Manager",
            approval_reason: "High value charge",
          },
        },
      };
    case "tpa-tax-exempt":
      return {
        ...base,
        rule_code: "RULE-TPA-TAX-EXEMPT-001",
        rule_name: "TPA room rent tax exemption",
        rule_type: "TAX",
        description: "Zero tax for TPA room rent.",
        conditions: {
          ...newGroup("all"),
          children: [
            { ...newCond("encounter.payer_type", "eq"), value: "TPA" },
            { ...newCond("charge_event.category", "eq"), value: "ROOM_RENT" },
          ],
        },
        actions: {
          tax: {
            target_field: DEFAULT_ACTION_TARGETS.tax,
            tax_percentage: "0.00",
            tax_type: "GST",
          },
        },
      };
    default:
      return base;
  }
}

export const TEMPLATES = [
  { key: "icu-tpa", name: "ICU Bed Price Override for TPA IPD", type: "PRICE_OVERRIDE" },
  { key: "senior-opd", name: "Senior Citizen OPD Discount", type: "DISCOUNT" },
  { key: "vip", name: "VIP Patient Discount", type: "DISCOUNT" },
  { key: "high-value", name: "High Value Billing Approval", type: "APPROVAL" },
  { key: "tpa-tax-exempt", name: "TPA Insurance Tax Exemption", type: "TAX" },
];

export function initialRule() {
  return makeTemplate("senior-opd");
}

export const SAMPLE_CONTEXT = {
  patient: { age: 65, gender: "MALE", metadata: { vip: false } },
  encounter: { encounter_type: "OPD", payer_type: "SELF" },
  charge_event: { category: "CONSULTATION", service_code: "GENERAL-CONSULT", unit_price: 1000, quantity: 1, gross_amount: 1000 },
};

export const RULE_TYPE_STYLES = {
  PRICE_OVERRIDE: { bg: "#E9F5FE", color: "#0d233f" },
  DISCOUNT: { bg: "#d1f2db", color: "#145a32" },
  TAX: { bg: "#e0e7ff", color: "#4338ca" },
  MARKUP: { bg: "#d1f2db", color: "#145a32" },
  APPROVAL: { bg: "#fff8e1", color: "#856404" },
  VALIDATION: { bg: "#fdecea", color: "#842029" },
  COMPOSITE: { bg: "#f1f5f9", color: "#64748b" },
};
